import styled from "@emotion/styled";
import {Container, Grid, Typography } from "@mui/material";
import React from "react";
import Heading from "../../../assets/Heading.png";
import PulseImg from "../../../assets/pulsechain.png";
import Pulsex from "../../../assets/PulseX_wordmark_black.png";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";

const HeaderContainer = styled(Container)`
    justify-content: center;
    display: flex;
    flex-direction: column;
    padding-bottom: 150px;
    @media (max-width: 749px){
        padding-top: 20px;
        padding-bottom: 20px;
    }
`
const SubHeading = styled(Typography)`
    color:#fff;
    font-family: poppins-m;
    font-size:20px ;
    text-align: center;
    @media (max-width: 600px){
        font-size: 18px;
    }
`
const SubHeadingTop = styled(Typography)`
    color:#fff;
    font-family: poppins-m;
    font-size:20px ;
    text-align: center;
    top:51%;
    position:absolute;
    @media (max-width: 1200px) and (min-width: 1000px){  
        position:absolute;
        top:54%;
    }
    @media (max-width: 1000px) and (min-width: 767px){  
        position:absolute;
        top:52%;
    }
    @media (max-width: 600px){
        font-size: 16px;
        margin-top:-35px;
    }
`
const P = styled.p`
    color: #fff;
    font-family: poppins-light;
    font-size: 15px;
    text-align: center;
    margin-top:0px;
    width:700px;
    @media (max-width: 600px){
        font-size: 13px;
    }
    @media (max-width: 900px){
        width:100%
    }
`
const ButtonWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
`
const BuyBtn = styled.a`
text-decoration: none;
    color:#000;
    background-color: #fff;
    border-radius: 9px;
    font-size: 18px;
    padding:6px 18px;
    border-color:#FFFFFF;
    border:1px solid #FFFFFF;
    @media (max-width: 600px){
        font-size: 16px;
        padding:8px 20px;
    }
`
const ChatBtn = styled.a`
    color:#fff;
    text-decoration: none;
    background-color: unset;
    border-radius: 9px;
    font-size: 18px;
    padding:6px 18px;
    border:1px solid #FFFFFF;
    margin-left: 10px;
    @media (max-width: 600px){
        font-size: 14px;
        padding:8px 20px;
    }
`
const GridContainer = styled(Grid)`
    display:flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`
const HeadingImg = styled.img`
    width:100%;
    max-width:100%;
    height:auto; 
`
const ContentGrid = styled(Grid)`
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
`
const ImgWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:20px;

`
const Header = () => {
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])
    return(
        <HeaderContainer maxWidth="xl" id="home" >
            <GridContainer container spacing={8}>
                <ContentGrid item xs={12} sm={12} md={12} lg={8} className="Padding-Top">
                    <HeadingImg  data-aos="zoom-in" src={Heading} />
                    <SubHeadingTop variant="h3"></SubHeadingTop>
                    <P  data-aos="zoom-in">Welcome to Pulse Mixer, the first mixer on the Pulse network that prioritizes your privacy.
                         With our innovative use of zero-knowledge protocols, we 
                         enable users to obfuscate their transactions, maintaining 
                        confidentiality and anonymity. Explore the possibilities of 
                        secure and private transactions with Pulse Mixer.
                    </P>
                    <ButtonWrapper data-aos="zoom-in">
                        <BuyBtn href="https://app.pulsex.com/swap?outputCurrency=0x6Dafcd59F3Acb2b7D9253E4dc1A6f81D19687F22" target="_blank">Buy Now</BuyBtn>
                        <ChatBtn href="https://dexscreener.com/pulsechain/0x69d085b1521f1039e2c9f094a47625d0470c65c1" target="_blank">View Chart</ChatBtn>
                    </ButtonWrapper>
                </ContentGrid>
                <Grid item xs={12} sm={10} md={8} >
                    <SubHeading  data-aos="zoom-in" variant="h3">View Us On</SubHeading>
                    <ImgWrapper  data-aos="zoom-in">
                       <a href="https://scan.pulsechain.com/address/0x6Dafcd59F3Acb2b7D9253E4dc1A6f81D19687F22" target="blank">

                        <img src={PulseImg} alt="" />
                       </a>
                       <a href="https://app.pulsex.com/swap?outputCurrency=0x6Dafcd59F3Acb2b7D9253E4dc1A6f81D19687F22"   target="blank">
                        <img src={Pulsex} alt="" style={{marginLeft:"15px"}}/>
                       </a>
                    </ImgWrapper>
                </Grid>
            </GridContainer>
        </HeaderContainer>
    );
}

export default Header;